module.exports = __webpack_public_path__ + "img/marker.44a51bf.png";